import React, { useEffect } from 'react';
import FooterSimple from '../common/footer/FooterSimple';
import HeaderNeg from '../common/header/HeaderNeg';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ColecctionCardanoTimeline2025 from '../component/timelines/ColecctionCardanoTimeline2025';
import SectionCardanoTimeline2025 from '../component/timelines/SectionCardanoTimeline2025';
import BannerCardanoTimeline2025 from '../component/banner/BannerCardanoTimeline2025';
import BannerYouTubeCT2025 from '../component/banner/BannerYouTubeCT2025';
import ReactGA from 'react-ga';

const CardanoTimeline2025 = () => {

    useEffect(() => {
        ReactGA.pageview('/cardano-timeline');
    }, []);

    return (
        <>
        <SEO title="Cardano Timeline 2025" />
        <ColorSwitcher />
        <main className="main-wrapper">
            <HeaderNeg />
            <BannerCardanoTimeline2025 />
            <div className="youtube-content bg-color-light">   
                <BannerYouTubeCT2025 /> 
            </div>  
            <ColecctionCardanoTimeline2025 />
            <SectionCardanoTimeline2025 />             

            <div className="section section-padding" id="section1">
                <div className="container">
                </div>
            </div>
                 
            <CtaLayoutOne />
            <FooterSimple />
        </main>
        </>
    )
}

export default CardanoTimeline2025;